import styled from "styled-components"

export const CheckboxWrapper = styled.input`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    &:focus{
        box-shadow: 0 0 0 0.25rem rgb(13 110 253 / 25%);
    }
`
